var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "mb-1" }, [
      _c("h4", { staticClass: "mb-1" }, [
        _vm._v(_vm._s(_vm.record.phone_number)),
      ]),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.record.operator,
              expression: "record.operator",
            },
          ],
          staticClass: "form-control",
          attrs: { disabled: "" },
          on: {
            change: function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.$set(
                _vm.record,
                "operator",
                $event.target.multiple ? $$selectedVal : $$selectedVal[0]
              )
            },
          },
        },
        [
          _c("option", { attrs: { value: "MTS" } }, [_vm._v("MTS")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "Beeline" } }, [_vm._v("Beeline")]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-6" }, [
        _c("div", { staticClass: "form-group" }, [
          _vm._v("\n        Слот\n        "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.record.slot,
                  expression: "record.slot",
                },
              ],
              staticClass: "form-control",
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.record,
                    "slot",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                },
              },
            },
            _vm._l(32, function (index) {
              return _c("option", { key: index, domProps: { value: index } }, [
                _vm._v(_vm._s(index)),
              ])
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _vm._v("\n        Логин в кабинет оператора\n        "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.record.extra.login,
                expression: "record.extra.login",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text" },
            domProps: { value: _vm.record.extra.login },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.record.extra, "login", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _vm._v("\n        Пароль\n        "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.record.extra.pass,
                expression: "record.extra.pass",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text" },
            domProps: { value: _vm.record.extra.pass },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.record.extra, "pass", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _vm._v("\n        Комментарий\n        "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.record.extra.comment,
                expression: "record.extra.comment",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text" },
            domProps: { value: _vm.record.extra.comment },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.record.extra, "comment", $event.target.value)
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-6" },
        [
          _c("p", { staticClass: "mb-1" }, [_vm._v("Расходы")]),
          _vm._v(" "),
          _c("div", { staticClass: "text-right mb-1" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-xs btn-outline-info",
                attrs: { type: "button" },
                on: { click: _vm.addExpenses },
              },
              [_vm._v("Добавить расход")]
            ),
          ]),
          _vm._v(" "),
          _vm._l(_vm.record.expenses, function (exp) {
            return !exp.toDelete
              ? _c("div", { staticClass: "ext_block mb-2" }, [
                  _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: exp.sum,
                          expression: "exp.sum",
                        },
                      ],
                      staticClass: "form-control sum_input",
                      attrs: {
                        type: "number",
                        disabled: exp.id,
                        placeholder: "Сумма",
                      },
                      domProps: { value: exp.sum },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(exp, "sum", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group-append" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: exp.comment,
                            expression: "exp.comment",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          disabled: exp.id,
                          type: "text",
                          placeholder: "Комментарий",
                        },
                        domProps: { value: exp.comment },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(exp, "comment", $event.target.value)
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: exp.regular,
                          expression: "exp.regular",
                        },
                      ],
                      attrs: { disabled: exp.id, type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(exp.regular)
                          ? _vm._i(exp.regular, null) > -1
                          : exp.regular,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = exp.regular,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(exp, "regular", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  exp,
                                  "regular",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(exp, "regular", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v(" Регулярный расход\n        "),
                  ]),
                  _vm._v(" "),
                  exp.regular
                    ? _c("div", [
                        _c("p", { staticClass: "mb-1" }, [
                          _vm._v("Повторять каждый"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: exp.period,
                                expression: "exp.period",
                              },
                            ],
                            staticClass: "form-control sum_input",
                            attrs: {
                              disabled: exp.id,
                              type: "number",
                              placeholder: "Период",
                            },
                            domProps: { value: exp.period },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(exp, "period", $event.target.value)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group-append" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: exp.period_type,
                                    expression: "exp.period_type",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { disabled: exp.id },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      exp,
                                      "period_type",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              [
                                _c("option", { attrs: { value: "month" } }, [
                                  _vm._v("Месяц"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "days" } }, [
                                  _vm._v("День"),
                                ]),
                              ]
                            ),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-right mt-1" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-xs btn-outline-danger",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            exp.toDelete = true
                          },
                        },
                      },
                      [_vm._v("удалить расход\n          ")]
                    ),
                  ]),
                ])
              : _vm._e()
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }